import { Plus } from "lucide-react";

interface InsertRailProps {
  onClick: () => void;
}

/**
 * Thin insert zone rendered between sections (and before the first / after
 * the last). On hover it reveals a dashed line and a centered "+" button.
 * Clicking opens the Section Library at that position.
 */
export function InsertRail({ onClick }: InsertRailProps) {
  return (
    <div className="group/insert relative h-0 py-[7px] -my-[7px] z-[8]">
      {/* Faint always-visible line -- hints at the insertion point */}
      <div className="absolute left-10 right-10 top-1/2 h-0 border-t border-dashed border-ink/[0.08] group-hover/insert:opacity-0 transition-opacity duration-150" />
      {/* Bold dashed line on hover */}
      <div className="absolute left-6 right-6 top-1/2 h-0 border-t-2 border-dashed border-tide opacity-0 group-hover/insert:opacity-100 transition-opacity duration-150" />

      {/* + button (counter-zoomed so it stays native-size when the canvas
          is scaled down; centered via flex because percentage offsets don't
          compose with a local zoom) */}
      <div className="absolute inset-0 z-[3] flex items-center justify-center pointer-events-none">
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            onClick();
          }}
          style={{ zoom: "var(--canvas-unzoom, 1)" }}
          className="pointer-events-auto w-[30px] h-[30px] rounded-full border-0 bg-tide text-white text-[18px] font-bold grid place-items-center opacity-0 scale-[0.7] group-hover/insert:opacity-100 group-hover/insert:scale-100 transition-all duration-150 shadow-[0_4px_12px_-2px_rgba(38,99,199,0.5)] cursor-pointer hover:shadow-[0_6px_16px_-2px_rgba(38,99,199,0.6)]"
          aria-label="Insert section"
        >
          <Plus size={16} strokeWidth={2.5} />
        </button>
      </div>
    </div>
  );
}
